import { a4 as sanitize_props, a1 as spread_props, a5 as slot, Y as attributes, a3 as clsx, V as bind_props, Z as attr_class, _ as stringify, X as ensure_array_like, W as attr } from "../../chunks/index.js";
import { I as Icon, a as Icon$1, S as Star$1, f as faqs, B as Badge, A as Award, F as File_text, U as Users, b as User_check, c as categories, W as Workshops, d as benefits, t as testimonials } from "../../chunks/Workshops.js";
import { c as cn, B as Button } from "../../chunks/button.js";
import { f as fallback, e as escape_html } from "../../chunks/context.js";
import { h as html, o as onDestroy } from "../../chunks/index-server.js";
import "countup.js";
function Chevron_left($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [["path", { "d": "m15 18-6-6 6-6" }]];
  Icon($$renderer, spread_props([
    { name: "chevron-left" },
    $$sanitized_props,
    {
      /**
       * @component @name ChevronLeft
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUgMTgtNi02IDYtNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/chevron-left
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Chevron_right($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [["path", { "d": "m9 18 6-6-6-6" }]];
  Icon($$renderer, spread_props([
    { name: "chevron-right" },
    $$sanitized_props,
    {
      /**
       * @component @name ChevronRight
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtOSAxOCA2LTYtNi02IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/chevron-right
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Quote($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    [
      "path",
      {
        "d": "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
      }
    ],
    [
      "path",
      {
        "d": "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
      }
    ]
  ];
  Icon($$renderer, spread_props([
    { name: "quote" },
    $$sanitized_props,
    {
      /**
       * @component @name Quote
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgM2EyIDIgMCAwIDAtMiAydjZhMiAyIDAgMCAwIDIgMiAxIDEgMCAwIDEgMSAxdjFhMiAyIDAgMCAxLTIgMiAxIDEgMCAwIDAtMSAxdjJhMSAxIDAgMCAwIDEgMSA2IDYgMCAwIDAgNi02VjVhMiAyIDAgMCAwLTItMnoiIC8+CiAgPHBhdGggZD0iTTUgM2EyIDIgMCAwIDAtMiAydjZhMiAyIDAgMCAwIDIgMiAxIDEgMCAwIDEgMSAxdjFhMiAyIDAgMCAxLTIgMiAxIDEgMCAwIDAtMSAxdjJhMSAxIDAgMCAwIDEgMSA2IDYgMCAwIDAgNi02VjVhMiAyIDAgMCAwLTItMnoiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/quote
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Arrow_right($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      ["path", { "d": "M5 12h14" }],
      ["path", { "d": "m12 5 7 7-7 7" }]
    ];
    Icon$1($$renderer2, spread_props([
      { name: "arrow-right" },
      /**
       * @component @name ArrowRight
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSAxMmgxNCIgLz4KICA8cGF0aCBkPSJtMTIgNSA3IDctNyA3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/arrow-right
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Circle_question_mark($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      ["circle", { "cx": "12", "cy": "12", "r": "10" }],
      ["path", { "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
      ["path", { "d": "M12 17h.01" }]
    ];
    Icon$1($$renderer2, spread_props([
      { name: "circle-question-mark" },
      /**
       * @component @name CircleQuestionMark
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8cGF0aCBkPSJNOS4wOSA5YTMgMyAwIDAgMSA1LjgzIDFjMCAyLTMgMy0zIDMiIC8+CiAgPHBhdGggZD0iTTEyIDE3aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/circle-question-mark
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Star($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      [
        "path",
        {
          "d": "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
        }
      ]
    ];
    Icon$1($$renderer2, spread_props([
      { name: "star" },
      /**
       * @component @name Star
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuNTI1IDIuMjk1YS41My41MyAwIDAgMSAuOTUgMGwyLjMxIDQuNjc5YTIuMTIzIDIuMTIzIDAgMCAwIDEuNTk1IDEuMTZsNS4xNjYuNzU2YS41My41MyAwIDAgMSAuMjk0LjkwNGwtMy43MzYgMy42MzhhMi4xMjMgMi4xMjMgMCAwIDAtLjYxMSAxLjg3OGwuODgyIDUuMTRhLjUzLjUzIDAgMCAxLS43NzEuNTZsLTQuNjE4LTIuNDI4YTIuMTIyIDIuMTIyIDAgMCAwLTEuOTczIDBMNi4zOTYgMjEuMDFhLjUzLjUzIDAgMCAxLS43Ny0uNTZsLjg4MS01LjEzOWEyLjEyMiAyLjEyMiAwIDAgMC0uNjExLTEuODc5TDIuMTYgOS43OTVhLjUzLjUzIDAgMCAxIC4yOTQtLjkwNmw1LjE2NS0uNzU1YTIuMTIyIDIuMTIyIDAgMCAwIDEuNTk3LTEuMTZ6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/star
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Card($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let {
      ref = null,
      class: className,
      children,
      $$slots,
      $$events,
      ...restProps
    } = $$props;
    $$renderer2.push(`<div${attributes({
      "data-slot": "card",
      class: clsx(cn("bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm", className)),
      ...restProps
    })}>`);
    children?.($$renderer2);
    $$renderer2.push(`<!----></div>`);
    bind_props($$props, { ref });
  });
}
function Card_content($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let {
      ref = null,
      class: className,
      children,
      $$slots,
      $$events,
      ...restProps
    } = $$props;
    $$renderer2.push(`<div${attributes({
      "data-slot": "card-content",
      class: clsx(cn("px-6", className)),
      ...restProps
    })}>`);
    children?.($$renderer2);
    $$renderer2.push(`<!----></div>`);
    bind_props($$props, { ref });
  });
}
function SmallCard($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let icon = $$props["icon"];
    let title = fallback($$props["title"], "");
    let iconColorClass = fallback($$props["iconColorClass"], "");
    let className = fallback($$props["className"], "");
    Card($$renderer2, {
      class: cn("shadow-theme flex min-h-[94px] cursor-pointer hover:bg-[var(--color-slate-800)]/100  flex-col items-center justify-center rounded-xl bg-[var(--color-slate-800,#1e293b)]/60 px-3 py-5 text-center border border-[rgba(255,255,255,0.09)]", className),
      children: ($$renderer3) => {
        Card_content($$renderer3, {
          class: "flex flex-col items-center justify-center p-0",
          children: ($$renderer4) => {
            $$renderer4.push(`<div${attr_class(clsx(cn("mx-auto mb-2", iconColorClass)))}>`);
            if (typeof icon === "string") {
              $$renderer4.push("<!--[-->");
              $$renderer4.push(`${html(icon)}`);
            } else {
              $$renderer4.push("<!--[!-->");
              if (typeof icon === "function") {
                $$renderer4.push("<!--[-->");
                $$renderer4.push(`<!---->`);
                icon?.($$renderer4, { size: 28 });
                $$renderer4.push(`<!---->`);
              } else {
                $$renderer4.push("<!--[!-->");
              }
              $$renderer4.push(`<!--]-->`);
            }
            $$renderer4.push(`<!--]--></div> <span class="text-[15px] md:text-base text-white mt-1">${escape_html(title)}</span>`);
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
    bind_props($$props, { icon, title, iconColorClass, className });
  });
}
function WorkshopCategory($$renderer, $$props) {
  let icon = $$props["icon"];
  let title = fallback($$props["title"], "");
  let workshops = fallback($$props["workshops"], 0);
  let iconColorClass = fallback($$props["iconColorClass"], "bg-blue-100 text-blue-500");
  let className = fallback($$props["className"], "");
  $$renderer.push(`<div${attr_class(`rounded-xl border bg-white px-4 py-4 flex flex-col gap-2 min-h-[110px] transition-shadow hover:shadow-md group cursor-pointer ${stringify(className)}`)}><div class="flex items-center justify-center mb-2"><div${attr_class(`size-10 flex items-center justify-center rounded-full text-xl ${stringify(iconColorClass)}`)}>`);
  if (typeof icon === "string") {
    $$renderer.push("<!--[-->");
    $$renderer.push(`${html(icon)}`);
  } else {
    $$renderer.push("<!--[!-->");
    if (typeof icon === "function") {
      $$renderer.push("<!--[-->");
      $$renderer.push(`<!---->`);
      icon?.($$renderer, {});
      $$renderer.push(`<!---->`);
    } else {
      $$renderer.push("<!--[!-->");
    }
    $$renderer.push(`<!--]-->`);
  }
  $$renderer.push(`<!--]--></div></div> <div class="text-center font-semibold text-gray-800 text-sm">${escape_html(title)}</div> <div class="text-center text-xs text-gray-400 font-medium">${escape_html(workshops)} Workshop${escape_html(workshops === 1 ? "" : "s")}</div></div>`);
  bind_props($$props, { icon, title, workshops, iconColorClass, className });
}
function CountdownTimer($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let countdown = fallback($$props["countdown"], () => ({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: false }), true);
    onDestroy(() => {
    });
    bind_props($$props, { countdown });
  });
}
function CountdownUnit($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let value = fallback($$props["value"], 0);
    let label = fallback($$props["label"], "");
    $$renderer2.push(`<div class="flex flex-col items-center"><span class="min-w-[50px] rounded-lg bg-[var(--color-primary,#f97316)] px-5 py-1.5 text-center font-mono text-2xl font-bold text-white">${escape_html(String(value).padStart(2, "0"))}</span> <span class="mt-1 text-xs text-[var(--color-gray-300,#d1d5db)] uppercase">${escape_html(label)}</span></div>`);
    bind_props($$props, { value, label });
  });
}
function CountdownCard($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let countdown = fallback($$props["countdown"], () => ({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: false }), true);
    $$renderer2.push(`<div class="shadow-theme w-full rounded-2xl border border-[var(--color-gray-700,#374151)] bg-[var(--color-slate-800,#1e293b)]/60 px-8 py-6 backdrop-blur"><div class="mb-4 text-center text-sm font-medium tracking-wide text-[var(--color-primary,#f97316)]"><span class="flex items-center justify-center gap-1 text-[var(--color-primary,#f97316)]"><svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor"></circle><path d="M12 6v6l4 2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg> Next Batch Starting In</span></div> <div class="mb-5 flex justify-center gap-5">`);
    CountdownUnit($$renderer2, { value: countdown.days, label: "Days" });
    $$renderer2.push(`<!----> `);
    CountdownUnit($$renderer2, { value: countdown.hours, label: "Hours" });
    $$renderer2.push(`<!----> `);
    CountdownUnit($$renderer2, { value: countdown.minutes, label: "Mins" });
    $$renderer2.push(`<!----> `);
    CountdownUnit($$renderer2, { value: countdown.seconds, label: "Secs" });
    $$renderer2.push(`<!----></div> `);
    if (countdown.expired) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<div class="text-center text-sm text-[var(--color-primary,#f97316)]">Course has started! Register for next batch.</div>`);
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--></div>`);
    bind_props($$props, { countdown });
  });
}
function Stats($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let stats = [
      {
        label: "Students Taught",
        value: 1e4,
        suffix: "+",
        duration: 2,
        element: null
      },
      {
        label: "Expert Tutors",
        value: 50,
        suffix: "+",
        duration: 1.5,
        element: null
      },
      {
        label: "Years Experience",
        value: 6,
        suffix: "+",
        duration: 1,
        element: null
      },
      {
        label: "Success Rate",
        value: 95,
        suffix: "%",
        duration: 1.5,
        element: null
      }
    ];
    $$renderer2.push(`<section class="py-8"><div class="container mx-auto px-4"><div class="rounded-2xl bg-gradient-to-r from-[#141d2b] to-[#23283f] flex flex-col sm:flex-row justify-between items-center gap-8 px-6 py-8"><!--[-->`);
    const each_array = ensure_array_like(stats);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let stat = each_array[$$index];
      $$renderer2.push(`<div class="flex-1 flex flex-col items-center"><span class="block text-2xl md:text-3xl font-bold text-orange-500">0${escape_html(stat.suffix)}</span> <span class="block text-xs md:text-sm text-gray-200 mt-1 tracking-wide">${escape_html(stat.label)}</span></div>`);
    }
    $$renderer2.push(`<!--]--></div></div></section>`);
  });
}
function Testimonials($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let current = 0;
    let testimonials2 = fallback($$props["testimonials"], () => [], true);
    $$renderer2.push(`<div class="relative max-w-4xl mx-auto"><div class="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 sm:p-12 min-h-[300px]">`);
    Quote($$renderer2, { class: "w-12 h-12 text-orange-500/50 mb-6" });
    $$renderer2.push(`<!----> <div class="transition-all duration-300"><div class="flex gap-1 mb-4"><!--[-->`);
    const each_array = ensure_array_like(Array(testimonials2[current].rating));
    for (let i = 0, $$length = each_array.length; i < $$length; i++) {
      each_array[i];
      Star$1($$renderer2, { class: "w-5 h-5 fill-orange-400 text-orange-400" });
    }
    $$renderer2.push(`<!--]--></div> <p class="text-xl sm:text-2xl text-white leading-relaxed mb-8">"${escape_html(testimonials2[current].content)}"</p> <div class="flex items-center gap-4"><img${attr("src", testimonials2[current].image)}${attr("alt", testimonials2[current].name)} class="w-14 h-14 rounded-full border-2 border-orange-500"/> <div><p class="font-semibold text-white">${escape_html(testimonials2[current].name)}</p> <p class="text-gray-400 text-sm">${escape_html(testimonials2[current].role)}</p></div></div></div></div> <div class="flex justify-center gap-4 mt-8">`);
    Button($$renderer2, {
      variant: "ghost",
      size: "icon",
      disabled: false,
      class: "rounded-full border-white/20 text-white hover:bg-white/10",
      children: ($$renderer3) => {
        Chevron_left($$renderer3, { class: "w-5 h-5" });
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----> <div class="flex items-center gap-2"><!--[-->`);
    const each_array_1 = ensure_array_like(testimonials2);
    for (let i = 0, $$length = each_array_1.length; i < $$length; i++) {
      each_array_1[i];
      $$renderer2.push(`<button${attr("aria-label", `Go to testimonial ${i + 1}`)}${attr_class(`w-2 h-2 rounded-full transition-all ${i === current ? "w-8 bg-orange-500" : "bg-white/30 hover:bg-white/50"}`)}></button>`);
    }
    $$renderer2.push(`<!--]--></div> `);
    Button($$renderer2, {
      variant: "ghost",
      size: "icon",
      disabled: false,
      class: "rounded-full border-white/20 text-white hover:bg-white/10",
      children: ($$renderer3) => {
        Chevron_right($$renderer3, { class: "w-5 h-5" });
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div></div>`);
    bind_props($$props, { testimonials: testimonials2 });
  });
}
function FAQItem($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let question = $$props["question"];
    let answer = $$props["answer"];
    let value = $$props["value"];
    let isOpen = fallback($$props["isOpen"], false);
    $$renderer2.push(`<div class="border-b border-gray-100 last:border-0"><button class="w-full px-6 py-5 text-left text-gray-900 hover:text-orange-600 hover:no-underline flex justify-between items-center"${attr("aria-expanded", isOpen)}${attr("aria-controls", `accordion-content-${value}`)}><span class="font-medium pr-4">${escape_html(question)}</span> <svg${attr_class(`w-4 h-4 transition-transform duration-200 ${stringify(isOpen ? "rotate-180" : "")}`)} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg></button> `);
    if (isOpen) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<div${attr("id", `accordion-content-${value}`)} class="px-6 pb-5 text-gray-600 leading-relaxed">${escape_html(answer)}</div>`);
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--></div>`);
    bind_props($$props, { question, answer, value, isOpen });
  });
}
function FAQSection($$renderer) {
  let openItem = null;
  $$renderer.push(`<div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"><!--[-->`);
  const each_array = ensure_array_like(faqs);
  for (let index = 0, $$length = each_array.length; index < $$length; index++) {
    let faq = each_array[index];
    FAQItem($$renderer, {
      question: faq.question,
      answer: faq.answer,
      value: `item-${index}`,
      isOpen: openItem === `item-${index}`
    });
  }
  $$renderer.push(`<!--]--></div> <div class="mt-12 bg-gradient-to-r from-orange-500 to-orange-500 rounded-2xl p-8 text-center"><h3 class="text-xl font-bold text-white mb-2">Still have questions?</h3> <p class="text-orange-100 mb-6">Our team is here to help you 24/7</p> <a href="https://wa.me/+917814688725" target="_blank" rel="noopener noreferrer" class="inline-block">`);
  Button($$renderer, {
    disabled: false,
    class: "bg-white text-orange-600 hover:bg-orange-50",
    href: "/workshops",
    children: ($$renderer2) => {
      $$renderer2.push(`<!---->workshop `);
      Arrow_right($$renderer2, { class: "w-4 h-4 mr-2" });
      $$renderer2.push(`<!---->`);
    },
    $$slots: { default: true }
  });
  $$renderer.push(`<!----></a></div>`);
}
function _page($$renderer) {
  let countdown;
  let selectedCategory = null;
  let $$settled = true;
  let $$inner_renderer;
  function $$render_inner($$renderer2) {
    $$renderer2.push(`<section class="relative flex min-h-[85vh] items-center overflow-hidden bg-[linear-gradient(120deg,#171e32_0%,#181d26_70%,#372012_100%)] py-16 text-white"><div class="container flex flex-col items-center justify-between md:flex-row"><div class="z-10 w-full max-w-xl"><div class="mb-4">`);
    Badge($$renderer2, {
      variant: "secondary",
      class: "shadow-theme bg-[var(--color-primary-light)] text-[var(--color-primary-dark)]",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->Limited Seats Available`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div> <h1 class="mb-3 text-4xl leading-tight font-bold md:text-5xl">Master New Skills<br/> With <span class="text-[var(--color-primary,#f97316)]">World'O'Tutors</span></h1> <p class="mt-3 mb-6 text-base text-[var(--color-gray-200,#e5e7eb)] md:text-lg">Join our premium workshops designed by expert tutors. Learn Coding, AI, Music, Dance &amp;
				more with personalized attention and certification.</p> <div class="mb-7 flex flex-wrap items-center gap-3">`);
    Badge($$renderer2, {
      variant: "secondary",
      class: "bg-[var(--color-primary-light,#fdba74)]/90 font-semibold text-[var(--color-primary-dark,#ea580c)]",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->1000+ Students`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----> `);
    Badge($$renderer2, {
      variant: "secondary",
      class: "bg-[var(--color-gray-800,#1f2937)]/80 font-semibold text-[var(--color-yellow,#facc15)]",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->Certified Courses`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----> `);
    Badge($$renderer2, {
      variant: "secondary",
      class: "bg-[var(--color-purple,#a21caf)]/80 font-semibold text-white",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->Live Sessions`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div> <div class="flex flex-row items-center gap-3">`);
    Button($$renderer2, {
      href: "#",
      size: "sm",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->Explore Workshops`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----> `);
    Button($$renderer2, {
      href: "#",
      size: "sm",
      variant: "ghost",
      class: "border",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->Explore Workshops`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div></div> <div class="z-20 mt-12 flex w-full max-w-lg flex-col items-center md:mt-0">`);
    CountdownTimer($$renderer2, {
      get countdown() {
        return countdown;
      },
      set countdown($$value) {
        countdown = $$value;
        $$settled = false;
      }
    });
    $$renderer2.push(`<!----> <div class="mb-6 w-full">`);
    CountdownCard($$renderer2, { countdown });
    $$renderer2.push(`<!----></div> <div class="grid w-full grid-cols-2 gap-4">`);
    SmallCard($$renderer2, {
      icon: Award,
      title: "Free Certificate",
      iconColorClass: "text-[var(--color-primary,#f97316)]"
    });
    $$renderer2.push(`<!----> `);
    SmallCard($$renderer2, {
      icon: File_text,
      title: "Class Notes",
      iconColorClass: "text-pink-400"
    });
    $$renderer2.push(`<!----> `);
    SmallCard($$renderer2, {
      icon: Users,
      title: "Expert Tutors",
      iconColorClass: "text-yellow-400"
    });
    $$renderer2.push(`<!----> `);
    SmallCard($$renderer2, {
      icon: User_check,
      title: "Personal Attention",
      iconColorClass: "text-fuchsia-400"
    });
    $$renderer2.push(`<!----></div></div></div></section> <section class="container mx-auto w-full py-10 md:py-16"><div class="mb-8 flex flex-col items-center">`);
    Badge($$renderer2, {
      class: "mb-2 rounded-full bg-yellow-100 px-3 py-1 text-[14px] font-semibold text-yellow-800",
      variant: "secondary",
      children: ($$renderer3) => {
        $$renderer3.push(`<span class="font-semibold">Explore Categories</span>`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----> <h2 class="mt-1 mb-1 text-center text-2xl font-bold md:text-[2rem]">Browse Workshops by Category</h2> <p class="max-w-2xl text-center text-gray-500">From core academic to enrichment programs, we offer workshops across all subjects</p></div> <div class="grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5"><!--[-->`);
    const each_array = ensure_array_like(categories);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let cat = each_array[$$index];
      WorkshopCategory($$renderer2, {
        icon: cat.icon,
        title: cat.title,
        workshops: cat.workshops,
        iconColorClass: cat.iconColorClass,
        className: cat.className
      });
    }
    $$renderer2.push(`<!--]--></div></section> <div>`);
    Workshops($$renderer2, { selectedCategory });
    $$renderer2.push(`<!----></div> <section class="py-16 bg-[linear-gradient(to_right,#fff_60%,#fff7ed_100%)]"><div class="container mx-auto px-4"><div class="flex flex-col items-center mb-9"><div class="mb-2"><span class="inline-flex bg-orange-100 text-orange-700 rounded-full px-3 py-1 text-xs font-semibold">Why Choose Us</span></div> <h2 class="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-2">Benefits of Learning with <span class="text-orange-500">World'O'Tutors</span></h2> <p class="text-gray-500 max-w-2xl text-center">Join thousands of students who have transformed their skills with our expert-led workshops</p></div> <div class="grid gap-6 md:grid-cols-3 sm:grid-cols-2"><!--[-->`);
    const each_array_1 = ensure_array_like(benefits);
    for (let i = 0, $$length = each_array_1.length; i < $$length; i++) {
      let benefit = each_array_1[i];
      $$renderer2.push(`<div${attr_class(`rounded-xl bg-white p-6 shadow-sm transition hover:shadow-lg h-full flex flex-col ${benefit.border}`, void 0, { "shadow-[0_2px_12px_#f7e7cb]": i === 2 })}><div${attr_class(`w-10 h-10 mb-4 flex items-center justify-center rounded-lg ${benefit.iconClasses} text-2xl`)}><!---->`);
      benefit.icon?.($$renderer2, {});
      $$renderer2.push(`<!----></div> <h3 class="text-base font-semibold mb-1">${escape_html(benefit.title)}</h3> <p class="text-gray-500 text-sm leading-normal">${escape_html(benefit.desc)}</p></div>`);
    }
    $$renderer2.push(`<!--]--></div></div></section> `);
    Stats($$renderer2);
    $$renderer2.push(`<!----> <section class="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-orange-900 relative overflow-hidden"><div class="absolute top-20 left-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl"></div> <div class="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div> <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative"><div class="text-center mb-16"><div class="inline-flex items-center gap-2 bg-white/10 text-orange-300 px-4 py-2 rounded-full text-sm font-medium mb-4">`);
    Star($$renderer2, { class: "w-4 h-4" });
    $$renderer2.push(`<!----> Testimonials</div> <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">What Parents Are Saying</h2> <p class="text-lg text-gray-300 max-w-2xl mx-auto">Hear from parents whose children have transformed their learning journey with us</p></div> `);
    Testimonials($$renderer2, { testimonials });
    $$renderer2.push(`<!----></div></section> <section class="py-20 bg-gray-50 relative overflow-hidden"><div class="absolute top-0 right-0 w-72 h-72 bg-orange-100 rounded-full blur-3xl opacity-50"></div> <div class="absolute bottom-0 left-0 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-50"></div> <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative"><div class="text-center mb-12"><div class="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-medium mb-4">`);
    Circle_question_mark($$renderer2, { class: "w-4 h-4" });
    $$renderer2.push(`<!----> FAQ</div> <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2> <p class="text-lg text-gray-600">Everything you need to know about our workshops</p></div> `);
    FAQSection($$renderer2);
    $$renderer2.push(`<!----></div></section>`);
  }
  do {
    $$settled = true;
    $$inner_renderer = $$renderer.copy();
    $$render_inner($$inner_renderer);
  } while (!$$settled);
  $$renderer.subsume($$inner_renderer);
}
export {
  _page as default
};
